import React, { FunctionComponent } from 'react';
import { map, includes } from 'ramda';

import { useUserMgmt, UserType } from 'components/UserMgmt/UserMgmt.context';
import { NavItems } from 'components/Header/components/Navigation/Navigation.helpers';
import { useGetMerchantVenueCounts } from 'helpers/useMerchantVenueCounts';

import { navItems } from './ExternalNav.helpers';
import MenuItem from '../MenuItem';

const renderMenuItems = (
  merchantName: string,
  userType: UserType,
  venueCounts: number,
) => ({
  path,
  label,
  key,
  userTypes,
  targetingRules = () => true,
}: NavItems) => {
  const disabled = venueCounts === 0 && userType === 'tier3';
  if (includes(userType as string, userTypes) && targetingRules(merchantName)) {
    return (
      <MenuItem
        path={`/${merchantName}${path}`}
        label={label}
        key={key}
        disabled={disabled}
      />
    );
  }
};

const ExternalNav: FunctionComponent = () => {
  const { venueCounts, loading: loadingVenues } = useGetMerchantVenueCounts();
  const { merchantName, userType } = useUserMgmt();

  if (loadingVenues) return null;

  return (
    <>{map(renderMenuItems(merchantName, userType, venueCounts), navItems)}</>
  );
};

export default ExternalNav;
